import ComplianceComment from '../../../types/common/ComplianceComment';
import ComplianceCommentModalState from '../../../components/Common/Modals/ComplianceCommentModal/ComplianceCommentModalState';

const createModalState = (comments: ComplianceComment[], url: string, isReadOnly?: boolean,componentId?:number): ComplianceCommentModalState => {

    let state = {} as ComplianceCommentModalState;

    state.isOpen = true;
    state.error = null;
    state.comments = comments;
    state.url = url;
    state.isReadOnly = isReadOnly || false;

    return state;
};

const complianceCommentHelper = {
    createModalState
};

export default complianceCommentHelper;
